import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const create = payload => api.post('/platform/api/v1/account', payload)

const getTestCompany = payload => api.get(`/platform/account/test-company`, payload)

const getPermissions = payload => api.get('/platform/privilege', payload)

const getUserData = payload => api.get(`/platform/admin/account/data/${payload.userId}`, payload)

const resetPassword = payload =>
  api.post('/platform/resetPassword', payload.data, { params: payload.params })

const getUserAccounts = payload => api.get('/platform/admin/account/manage', payload)

const getUserRoles = payload => api.get('/platform/admin/account/select/role', payload)

const getCustodians = payload => api.get('/platform/account/select/custodian', payload)

const createAccount = payload =>
  api.post(`/platform/admin/account`, payload.data, { params: payload.params })

const editAccount = payload =>
  api.put(`/platform/admin/account/manage`, payload.data, {
    params: payload.params,
  })

const deleteAccount = payload =>
  api.delete(`/platform/admin/account/manage/${payload.userId}`, { params: payload.params })

const getCompany = payload => api.get('/platform/admin/company', payload)

export default {
  create,
  getTestCompany,
  getPermissions,
  getUserData,
  resetPassword,
  getUserAccounts,
  getUserRoles,
  getCustodians,
  createAccount,
  editAccount,
  deleteAccount,
  getCompany,
}
